import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  constructor(
    private http: HttpClient
  ) { }

  getProducts() {
    return this.http.get(`${environment.apiUrl}/products`);
  }

  createProduct(product: any) {
    return this.http.post(`${environment.apiUrl}/products`, product);
  }
  
  getProductById(id: number) {
    return this.http.get(`${environment.apiUrl}/products/${id}`);
  }

  updateProduct(product: any) {
    return this.http.put(`${environment.apiUrl}/products/${product.id}`, product);
  }


  deleteProduct(id: number) {
    return this.http.delete(`${environment.apiUrl}/products/${id}`);
  }
}
